import { render, staticRenderFns } from "./thematicAreaReport.vue?vue&type=template&id=4d483275&scoped=true"
import script from "./thematicAreaReport.vue?vue&type=script&lang=js"
export * from "./thematicAreaReport.vue?vue&type=script&lang=js"
import style0 from "./thematicAreaReport.vue?vue&type=style&index=0&id=4d483275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d483275",
  null
  
)

export default component.exports